import styles from './speed-dial.module.scss';
import MaterialSpeedDial from '@mui/material/SpeedDial';
import MaterialSpeedDialAction from '@mui/material/SpeedDialAction';
import MaterialSpeedDialIcon from '@mui/material/SpeedDialIcon';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface SpeedDialProps {
  ariaLabel: string,
  children: any,
  // classes?: object,
  direction?: 'down' | 'left' | 'right' | 'up',
  // FabProps?: object,
  hidden?: boolean,
  icon?: ReactNode,
  // onClose?: (event: object, reason: string) => void,
  // onOpen?: (event: object, reason: string) => void,
  // open?: boolean,
  // openIcon?: ReactNode,
  sx?: any,
  // TransitionComponent?: any,
  // transitionDuration?: number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object
}

export interface SpeedDialActionProps {
  // classes?: object,
  // delay?: number,
  // FabProps?: object,
  icon?: ReactNode,
  // id?: string,
  open?: boolean,
  // sx?: any,
  // TooltipClasses?: object,
  // tooltipOpen?: boolean,
  // tooltipPlacement?:'bottom-end'| 'bottom-start'| 'bottom'| 'left-end'| 'left-start'| 'left'| 'right-end'| 'right-start'| 'right'| 'top-end'| 'top-start' | 'top',
  tooltipTitle?: ReactNode
}

export interface SpeedDialIconProps {
  // classes?: object,
  icon?: ReactNode,
  // openIcon?: ReactNode,
  sx?: any
}

export function SpeedDial(props: SpeedDialProps) {
  return (
    <MaterialSpeedDial
      ariaLabel={props.ariaLabel}
      sx={props.sx}
      icon={props.icon}
      direction={props.direction}
      hidden={props.hidden}>
      {props.children}
    </MaterialSpeedDial>
  );
}

export function SpeedDialAction(props: SpeedDialActionProps) {
  return (
    <MaterialSpeedDialAction
      icon={props.icon}
      tooltipTitle={props.tooltipTitle}
      open={props.open}
    />
  );
}

export function SpeedDialIcon(props: SpeedDialIconProps) {
  return (
    <MaterialSpeedDialIcon
      icon={props.icon}
      sx={props.sx}
    />
  );
}

export default SpeedDial;